var map = {
	"./ar/about": [
		82658,
		82658
	],
	"./ar/about-quran": [
		66437,
		66437
	],
	"./ar/about-quran.json": [
		66437,
		66437
	],
	"./ar/about.json": [
		82658,
		82658
	],
	"./ar/apps": [
		88452,
		88452
	],
	"./ar/apps.json": [
		88452,
		88452
	],
	"./ar/chapter": [
		56832,
		56832
	],
	"./ar/chapter.json": [
		56832,
		56832
	],
	"./ar/collection": [
		58376,
		58376
	],
	"./ar/collection.json": [
		58376,
		58376
	],
	"./ar/common": [
		11111,
		11111
	],
	"./ar/common.json": [
		11111,
		11111
	],
	"./ar/developers": [
		16242,
		16242
	],
	"./ar/developers.json": [
		16242,
		16242
	],
	"./ar/error": [
		64196,
		64196
	],
	"./ar/error.json": [
		64196,
		64196
	],
	"./ar/home": [
		50609,
		50609
	],
	"./ar/home.json": [
		50609,
		50609
	],
	"./ar/learn": [
		50619,
		50619
	],
	"./ar/learn.json": [
		50619,
		50619
	],
	"./ar/login": [
		44927,
		44927
	],
	"./ar/login.json": [
		44927,
		44927
	],
	"./ar/notes": [
		41382,
		41382
	],
	"./ar/notes.json": [
		41382,
		41382
	],
	"./ar/notification-settings": [
		95187,
		95187
	],
	"./ar/notification-settings.json": [
		95187,
		95187
	],
	"./ar/onboarding": [
		89181,
		89181
	],
	"./ar/onboarding.json": [
		89181,
		89181
	],
	"./ar/privacy": [
		40556,
		40556
	],
	"./ar/privacy.json": [
		40556,
		40556
	],
	"./ar/product-updates": [
		51896,
		51896
	],
	"./ar/product-updates.json": [
		51896,
		51896
	],
	"./ar/profile": [
		45340,
		45340
	],
	"./ar/profile.json": [
		45340,
		45340
	],
	"./ar/quick-links": [
		82937,
		82937
	],
	"./ar/quick-links.json": [
		82937,
		82937
	],
	"./ar/quran-reader": [
		61763,
		61763
	],
	"./ar/quran-reader.json": [
		61763,
		61763
	],
	"./ar/quranic-calendar": [
		13298,
		13298
	],
	"./ar/quranic-calendar.json": [
		13298,
		13298
	],
	"./ar/radio": [
		32772,
		32772
	],
	"./ar/radio.json": [
		32772,
		32772
	],
	"./ar/ramadan-activities": [
		30819,
		30819
	],
	"./ar/ramadan-activities.json": [
		30819,
		30819
	],
	"./ar/reading-goal": [
		612,
		612
	],
	"./ar/reading-goal.json": [
		612,
		612
	],
	"./ar/reading-progress": [
		58536,
		58536
	],
	"./ar/reading-progress.json": [
		58536,
		58536
	],
	"./ar/reciter": [
		160,
		160
	],
	"./ar/reciter.json": [
		160,
		160
	],
	"./ar/search": [
		93200,
		54239
	],
	"./ar/search.json": [
		93200,
		54239
	],
	"./ar/support": [
		19847,
		19847
	],
	"./ar/support.json": [
		19847,
		19847
	],
	"./ar/surah-info": [
		4198,
		4198
	],
	"./ar/surah-info.json": [
		4198,
		4198
	],
	"./ar/tajweed": [
		72419,
		72419
	],
	"./ar/tajweed.json": [
		72419,
		72419
	],
	"./bn/about": [
		96913,
		96913
	],
	"./bn/about-quran": [
		84124,
		84124
	],
	"./bn/about-quran.json": [
		84124,
		84124
	],
	"./bn/about.json": [
		96913,
		96913
	],
	"./bn/apps": [
		79618,
		79618
	],
	"./bn/apps.json": [
		79618,
		79618
	],
	"./bn/chapter": [
		97747,
		97747
	],
	"./bn/chapter.json": [
		97747,
		97747
	],
	"./bn/collection": [
		15603,
		15603
	],
	"./bn/collection.json": [
		15603,
		15603
	],
	"./bn/common": [
		50371,
		50371
	],
	"./bn/common.json": [
		50371,
		50371
	],
	"./bn/developers": [
		32966,
		32966
	],
	"./bn/developers.json": [
		32966,
		32966
	],
	"./bn/error": [
		83328,
		83328
	],
	"./bn/error.json": [
		83328,
		83328
	],
	"./bn/home": [
		82481,
		82481
	],
	"./bn/home.json": [
		82481,
		82481
	],
	"./bn/learn": [
		69635,
		69635
	],
	"./bn/learn.json": [
		69635,
		69635
	],
	"./bn/login": [
		81902,
		81902
	],
	"./bn/login.json": [
		81902,
		81902
	],
	"./bn/notes": [
		71439,
		71439
	],
	"./bn/notes.json": [
		71439,
		71439
	],
	"./bn/notification-settings": [
		99800,
		99800
	],
	"./bn/notification-settings.json": [
		99800,
		99800
	],
	"./bn/onboarding": [
		76259,
		76259
	],
	"./bn/onboarding.json": [
		76259,
		76259
	],
	"./bn/privacy": [
		34291,
		34291
	],
	"./bn/privacy.json": [
		34291,
		34291
	],
	"./bn/product-updates": [
		7596,
		7596
	],
	"./bn/product-updates.json": [
		7596,
		7596
	],
	"./bn/profile": [
		10188,
		10188
	],
	"./bn/profile.json": [
		10188,
		10188
	],
	"./bn/quick-links": [
		24464,
		24464
	],
	"./bn/quick-links.json": [
		24464,
		24464
	],
	"./bn/quran-reader": [
		31260,
		31260
	],
	"./bn/quran-reader.json": [
		31260,
		31260
	],
	"./bn/quranic-calendar": [
		87320,
		87320
	],
	"./bn/quranic-calendar.json": [
		87320,
		87320
	],
	"./bn/radio": [
		25772,
		25772
	],
	"./bn/radio.json": [
		25772,
		25772
	],
	"./bn/ramadan-activities": [
		65062,
		65062
	],
	"./bn/ramadan-activities.json": [
		65062,
		65062
	],
	"./bn/reading-goal": [
		82535,
		82535
	],
	"./bn/reading-goal.json": [
		82535,
		82535
	],
	"./bn/reading-progress": [
		6706,
		6706
	],
	"./bn/reading-progress.json": [
		6706,
		6706
	],
	"./bn/reciter": [
		53695,
		53695
	],
	"./bn/reciter.json": [
		53695,
		53695
	],
	"./bn/search": [
		90067,
		90067
	],
	"./bn/search.json": [
		90067,
		90067
	],
	"./bn/support": [
		11906,
		11906
	],
	"./bn/support.json": [
		11906,
		11906
	],
	"./bn/surah-info": [
		27050,
		27050
	],
	"./bn/surah-info.json": [
		27050,
		27050
	],
	"./bn/tajweed": [
		2552,
		2552
	],
	"./bn/tajweed.json": [
		2552,
		2552
	],
	"./en/about": [
		49740,
		49740
	],
	"./en/about-quran": [
		52008,
		52008
	],
	"./en/about-quran.json": [
		52008,
		52008
	],
	"./en/about.json": [
		49740,
		49740
	],
	"./en/apps": [
		46807,
		46807
	],
	"./en/apps.json": [
		46807,
		46807
	],
	"./en/chapter": [
		97821,
		97821
	],
	"./en/chapter.json": [
		97821,
		97821
	],
	"./en/collection": [
		49421,
		49421
	],
	"./en/collection.json": [
		49421,
		49421
	],
	"./en/common": [
		40464,
		40464
	],
	"./en/common.json": [
		40464,
		40464
	],
	"./en/developers": [
		44663,
		44663
	],
	"./en/developers.json": [
		44663,
		44663
	],
	"./en/error": [
		50394,
		50394
	],
	"./en/error.json": [
		50394,
		50394
	],
	"./en/home": [
		12482,
		12482
	],
	"./en/home.json": [
		12482,
		12482
	],
	"./en/learn": [
		66694,
		66694
	],
	"./en/learn.json": [
		66694,
		66694
	],
	"./en/login": [
		16318,
		16318
	],
	"./en/login.json": [
		16318,
		16318
	],
	"./en/notes": [
		23580,
		23580
	],
	"./en/notes.json": [
		23580,
		23580
	],
	"./en/notification-settings": [
		53145,
		53145
	],
	"./en/notification-settings.json": [
		53145,
		53145
	],
	"./en/onboarding": [
		42002,
		42002
	],
	"./en/onboarding.json": [
		42002,
		42002
	],
	"./en/privacy": [
		2297,
		2297
	],
	"./en/privacy.json": [
		2297,
		2297
	],
	"./en/product-updates": [
		21924,
		21924
	],
	"./en/product-updates.json": [
		21924,
		21924
	],
	"./en/profile": [
		81140,
		81140
	],
	"./en/profile.json": [
		81140,
		81140
	],
	"./en/quick-links": [
		36667,
		36667
	],
	"./en/quick-links.json": [
		36667,
		36667
	],
	"./en/quran-media-maker": [
		52403,
		52403
	],
	"./en/quran-media-maker.json": [
		52403,
		52403
	],
	"./en/quran-reader": [
		63151,
		63151
	],
	"./en/quran-reader.json": [
		63151,
		63151
	],
	"./en/quranic-calendar": [
		49294,
		49294
	],
	"./en/quranic-calendar.json": [
		49294,
		49294
	],
	"./en/radio": [
		40333,
		40333
	],
	"./en/radio.json": [
		40333,
		40333
	],
	"./en/ramadan-activities": [
		64007,
		64007
	],
	"./en/ramadan-activities.json": [
		64007,
		64007
	],
	"./en/reading-goal": [
		81098,
		81098
	],
	"./en/reading-goal.json": [
		81098,
		81098
	],
	"./en/reading-progress": [
		38725,
		38725
	],
	"./en/reading-progress.json": [
		38725,
		38725
	],
	"./en/reciter": [
		42121,
		42121
	],
	"./en/reciter.json": [
		42121,
		42121
	],
	"./en/search": [
		17842,
		17842
	],
	"./en/search.json": [
		17842,
		17842
	],
	"./en/support": [
		69251,
		69251
	],
	"./en/support.json": [
		69251,
		69251
	],
	"./en/surah-info": [
		19435,
		19435
	],
	"./en/surah-info.json": [
		19435,
		19435
	],
	"./en/tajweed": [
		27848,
		27848
	],
	"./en/tajweed.json": [
		27848,
		27848
	],
	"./es_US/common": [
		10603,
		10603
	],
	"./es_US/common.json": [
		10603,
		10603
	],
	"./fa/about": [
		62755,
		62755
	],
	"./fa/about-quran": [
		83331,
		83331
	],
	"./fa/about-quran.json": [
		83331,
		83331
	],
	"./fa/about.json": [
		62755,
		62755
	],
	"./fa/apps": [
		25265,
		25265
	],
	"./fa/apps.json": [
		25265,
		25265
	],
	"./fa/chapter": [
		24280,
		24280
	],
	"./fa/chapter.json": [
		24280,
		24280
	],
	"./fa/collection": [
		79382,
		79382
	],
	"./fa/collection.json": [
		79382,
		79382
	],
	"./fa/common": [
		70512,
		70512
	],
	"./fa/common.json": [
		70512,
		70512
	],
	"./fa/developers": [
		62319,
		62319
	],
	"./fa/developers.json": [
		62319,
		62319
	],
	"./fa/error": [
		23745,
		23745
	],
	"./fa/error.json": [
		23745,
		23745
	],
	"./fa/home": [
		17859,
		17859
	],
	"./fa/home.json": [
		17859,
		17859
	],
	"./fa/learn": [
		58586,
		58586
	],
	"./fa/learn.json": [
		58586,
		58586
	],
	"./fa/login": [
		18963,
		18963
	],
	"./fa/login.json": [
		18963,
		18963
	],
	"./fa/notes": [
		60573,
		60573
	],
	"./fa/notes.json": [
		60573,
		60573
	],
	"./fa/notification-settings": [
		86924,
		86924
	],
	"./fa/notification-settings.json": [
		86924,
		86924
	],
	"./fa/onboarding": [
		40281,
		40281
	],
	"./fa/onboarding.json": [
		40281,
		40281
	],
	"./fa/privacy": [
		98917,
		98917
	],
	"./fa/privacy.json": [
		98917,
		98917
	],
	"./fa/product-updates": [
		49264,
		79891
	],
	"./fa/product-updates.json": [
		49264,
		79891
	],
	"./fa/profile": [
		92620,
		92620
	],
	"./fa/profile.json": [
		92620,
		92620
	],
	"./fa/quick-links": [
		20689,
		20689
	],
	"./fa/quick-links.json": [
		20689,
		20689
	],
	"./fa/quran-reader": [
		56847,
		56847
	],
	"./fa/quran-reader.json": [
		56847,
		56847
	],
	"./fa/quranic-calendar": [
		59652,
		59652
	],
	"./fa/quranic-calendar.json": [
		59652,
		59652
	],
	"./fa/radio": [
		67110,
		67110
	],
	"./fa/radio.json": [
		67110,
		67110
	],
	"./fa/ramadan-activities": [
		72898,
		72898
	],
	"./fa/ramadan-activities.json": [
		72898,
		72898
	],
	"./fa/reading-goal": [
		16524,
		16524
	],
	"./fa/reading-goal.json": [
		16524,
		16524
	],
	"./fa/reading-progress": [
		11139,
		11139
	],
	"./fa/reading-progress.json": [
		11139,
		11139
	],
	"./fa/reciter": [
		77097,
		77097
	],
	"./fa/reciter.json": [
		77097,
		77097
	],
	"./fa/search": [
		20074,
		20074
	],
	"./fa/search.json": [
		20074,
		20074
	],
	"./fa/support": [
		86540,
		86540
	],
	"./fa/support.json": [
		86540,
		86540
	],
	"./fa/surah-info": [
		81131,
		81131
	],
	"./fa/surah-info.json": [
		81131,
		81131
	],
	"./fa/tajweed": [
		85510,
		85510
	],
	"./fa/tajweed.json": [
		85510,
		85510
	],
	"./fr/about": [
		85754,
		85754
	],
	"./fr/about-quran": [
		36836,
		36836
	],
	"./fr/about-quran.json": [
		36836,
		36836
	],
	"./fr/about.json": [
		85754,
		85754
	],
	"./fr/apps": [
		15582,
		15582
	],
	"./fr/apps.json": [
		15582,
		15582
	],
	"./fr/chapter": [
		98010,
		98010
	],
	"./fr/chapter.json": [
		98010,
		98010
	],
	"./fr/collection": [
		15926,
		15926
	],
	"./fr/collection.json": [
		15926,
		15926
	],
	"./fr/common": [
		45167,
		45167
	],
	"./fr/common.json": [
		45167,
		45167
	],
	"./fr/developers": [
		36538,
		36538
	],
	"./fr/developers.json": [
		36538,
		36538
	],
	"./fr/error": [
		82716,
		82716
	],
	"./fr/error.json": [
		82716,
		82716
	],
	"./fr/home": [
		31660,
		31660
	],
	"./fr/home.json": [
		31660,
		31660
	],
	"./fr/learn": [
		56415,
		56415
	],
	"./fr/learn.json": [
		56415,
		56415
	],
	"./fr/login": [
		76626,
		76626
	],
	"./fr/login.json": [
		76626,
		76626
	],
	"./fr/notes": [
		37650,
		37650
	],
	"./fr/notes.json": [
		37650,
		37650
	],
	"./fr/notification-settings": [
		15528,
		15528
	],
	"./fr/notification-settings.json": [
		15528,
		15528
	],
	"./fr/onboarding": [
		92408,
		92408
	],
	"./fr/onboarding.json": [
		92408,
		92408
	],
	"./fr/privacy": [
		26906,
		26906
	],
	"./fr/privacy.json": [
		26906,
		26906
	],
	"./fr/product-updates": [
		98750,
		98750
	],
	"./fr/product-updates.json": [
		98750,
		98750
	],
	"./fr/profile": [
		51763,
		51763
	],
	"./fr/profile.json": [
		51763,
		51763
	],
	"./fr/quick-links": [
		54833,
		54833
	],
	"./fr/quick-links.json": [
		54833,
		54833
	],
	"./fr/quran-reader": [
		55274,
		55274
	],
	"./fr/quran-reader.json": [
		55274,
		55274
	],
	"./fr/quranic-calendar": [
		99416,
		99416
	],
	"./fr/quranic-calendar.json": [
		99416,
		99416
	],
	"./fr/radio": [
		17325,
		17325
	],
	"./fr/radio.json": [
		17325,
		17325
	],
	"./fr/ramadan-activities": [
		36247,
		36247
	],
	"./fr/ramadan-activities.json": [
		36247,
		36247
	],
	"./fr/reading-goal": [
		95581,
		95581
	],
	"./fr/reading-goal.json": [
		95581,
		95581
	],
	"./fr/reading-progress": [
		58464,
		58464
	],
	"./fr/reading-progress.json": [
		58464,
		58464
	],
	"./fr/reciter": [
		24777,
		24777
	],
	"./fr/reciter.json": [
		24777,
		24777
	],
	"./fr/search": [
		77194,
		77194
	],
	"./fr/search.json": [
		77194,
		77194
	],
	"./fr/support": [
		51517,
		51517
	],
	"./fr/support.json": [
		51517,
		51517
	],
	"./fr/surah-info": [
		70203,
		70203
	],
	"./fr/surah-info.json": [
		70203,
		70203
	],
	"./fr/tajweed": [
		39419,
		39419
	],
	"./fr/tajweed.json": [
		39419,
		39419
	],
	"./id/about": [
		49146,
		49146
	],
	"./id/about-quran": [
		58554,
		58554
	],
	"./id/about-quran.json": [
		58554,
		58554
	],
	"./id/about.json": [
		49146,
		49146
	],
	"./id/apps": [
		88816,
		88816
	],
	"./id/apps.json": [
		88816,
		88816
	],
	"./id/chapter": [
		11888,
		11888
	],
	"./id/chapter.json": [
		11888,
		11888
	],
	"./id/collection": [
		49451,
		49451
	],
	"./id/collection.json": [
		49451,
		49451
	],
	"./id/common": [
		81610,
		81610
	],
	"./id/common.json": [
		81610,
		81610
	],
	"./id/developers": [
		61597,
		61597
	],
	"./id/developers.json": [
		61597,
		61597
	],
	"./id/error": [
		72819,
		72819
	],
	"./id/error.json": [
		72819,
		72819
	],
	"./id/home": [
		96903,
		96903
	],
	"./id/home.json": [
		96903,
		96903
	],
	"./id/learn": [
		76593,
		76593
	],
	"./id/learn.json": [
		76593,
		76593
	],
	"./id/login": [
		74675,
		74675
	],
	"./id/login.json": [
		74675,
		74675
	],
	"./id/notes": [
		66176,
		66176
	],
	"./id/notes.json": [
		66176,
		66176
	],
	"./id/notification-settings": [
		43707,
		43707
	],
	"./id/notification-settings.json": [
		43707,
		43707
	],
	"./id/onboarding": [
		61471,
		61471
	],
	"./id/onboarding.json": [
		61471,
		61471
	],
	"./id/privacy": [
		10399,
		10399
	],
	"./id/privacy.json": [
		10399,
		10399
	],
	"./id/product-updates": [
		71573,
		71573
	],
	"./id/product-updates.json": [
		71573,
		71573
	],
	"./id/profile": [
		51702,
		51702
	],
	"./id/profile.json": [
		51702,
		51702
	],
	"./id/quick-links": [
		23168,
		23168
	],
	"./id/quick-links.json": [
		23168,
		23168
	],
	"./id/quran-reader": [
		93981,
		93981
	],
	"./id/quran-reader.json": [
		93981,
		93981
	],
	"./id/quranic-calendar": [
		33814,
		33814
	],
	"./id/quranic-calendar.json": [
		33814,
		33814
	],
	"./id/radio": [
		86174,
		86174
	],
	"./id/radio.json": [
		86174,
		86174
	],
	"./id/ramadan-activities": [
		65927,
		65927
	],
	"./id/ramadan-activities.json": [
		65927,
		65927
	],
	"./id/reading-goal": [
		16448,
		16448
	],
	"./id/reading-goal.json": [
		16448,
		16448
	],
	"./id/reading-progress": [
		81892,
		81892
	],
	"./id/reading-progress.json": [
		81892,
		81892
	],
	"./id/reciter": [
		56576,
		56576
	],
	"./id/reciter.json": [
		56576,
		56576
	],
	"./id/search": [
		20794,
		20794
	],
	"./id/search.json": [
		20794,
		20794
	],
	"./id/support": [
		18974,
		18974
	],
	"./id/support.json": [
		18974,
		18974
	],
	"./id/surah-info": [
		77717,
		77717
	],
	"./id/surah-info.json": [
		77717,
		77717
	],
	"./id/tajweed": [
		46233,
		46233
	],
	"./id/tajweed.json": [
		46233,
		46233
	],
	"./it/about": [
		216,
		216
	],
	"./it/about-quran": [
		63782,
		63782
	],
	"./it/about-quran.json": [
		63782,
		63782
	],
	"./it/about.json": [
		216,
		216
	],
	"./it/apps": [
		65396,
		65396
	],
	"./it/apps.json": [
		65396,
		65396
	],
	"./it/chapter": [
		47097,
		47097
	],
	"./it/chapter.json": [
		47097,
		47097
	],
	"./it/collection": [
		95656,
		95656
	],
	"./it/collection.json": [
		95656,
		95656
	],
	"./it/common": [
		9486,
		9486
	],
	"./it/common.json": [
		9486,
		9486
	],
	"./it/developers": [
		10626,
		10626
	],
	"./it/developers.json": [
		10626,
		10626
	],
	"./it/error": [
		91259,
		91259
	],
	"./it/error.json": [
		91259,
		91259
	],
	"./it/home": [
		53765,
		53765
	],
	"./it/home.json": [
		53765,
		53765
	],
	"./it/learn": [
		36629,
		36629
	],
	"./it/learn.json": [
		36629,
		36629
	],
	"./it/login": [
		91153,
		91153
	],
	"./it/login.json": [
		91153,
		91153
	],
	"./it/notes": [
		25457,
		25457
	],
	"./it/notes.json": [
		25457,
		25457
	],
	"./it/notification-settings": [
		93529,
		93529
	],
	"./it/notification-settings.json": [
		93529,
		93529
	],
	"./it/onboarding": [
		83818,
		83818
	],
	"./it/onboarding.json": [
		83818,
		83818
	],
	"./it/privacy": [
		94987,
		94987
	],
	"./it/privacy.json": [
		94987,
		94987
	],
	"./it/product-updates": [
		53558,
		53558
	],
	"./it/product-updates.json": [
		53558,
		53558
	],
	"./it/profile": [
		21618,
		21618
	],
	"./it/profile.json": [
		21618,
		21618
	],
	"./it/quick-links": [
		86406,
		86406
	],
	"./it/quick-links.json": [
		86406,
		86406
	],
	"./it/quran-reader": [
		95016,
		95016
	],
	"./it/quran-reader.json": [
		95016,
		95016
	],
	"./it/quranic-calendar": [
		98849,
		98849
	],
	"./it/quranic-calendar.json": [
		98849,
		98849
	],
	"./it/radio": [
		55570,
		55570
	],
	"./it/radio.json": [
		55570,
		55570
	],
	"./it/ramadan-activities": [
		38796,
		38796
	],
	"./it/ramadan-activities.json": [
		38796,
		38796
	],
	"./it/reading-goal": [
		98503,
		98503
	],
	"./it/reading-goal.json": [
		98503,
		98503
	],
	"./it/reading-progress": [
		90188,
		90188
	],
	"./it/reading-progress.json": [
		90188,
		90188
	],
	"./it/reciter": [
		39905,
		39905
	],
	"./it/reciter.json": [
		39905,
		39905
	],
	"./it/search": [
		5175,
		5175
	],
	"./it/search.json": [
		5175,
		5175
	],
	"./it/support": [
		88600,
		88600
	],
	"./it/support.json": [
		88600,
		88600
	],
	"./it/surah-info": [
		90940,
		90940
	],
	"./it/surah-info.json": [
		90940,
		90940
	],
	"./it/tajweed": [
		23442,
		23442
	],
	"./it/tajweed.json": [
		23442,
		23442
	],
	"./ms/about": [
		50029,
		50029
	],
	"./ms/about-quran": [
		30999,
		30999
	],
	"./ms/about-quran.json": [
		30999,
		30999
	],
	"./ms/about.json": [
		50029,
		50029
	],
	"./ms/apps": [
		96282,
		96282
	],
	"./ms/apps.json": [
		96282,
		96282
	],
	"./ms/chapter": [
		41641,
		41641
	],
	"./ms/chapter.json": [
		41641,
		41641
	],
	"./ms/collection": [
		73218,
		73218
	],
	"./ms/collection.json": [
		73218,
		73218
	],
	"./ms/common": [
		85223,
		85223
	],
	"./ms/common.json": [
		85223,
		85223
	],
	"./ms/developers": [
		6259,
		6259
	],
	"./ms/developers.json": [
		6259,
		6259
	],
	"./ms/error": [
		29620,
		29620
	],
	"./ms/error.json": [
		29620,
		29620
	],
	"./ms/home": [
		98950,
		98950
	],
	"./ms/home.json": [
		98950,
		98950
	],
	"./ms/learn": [
		10132,
		10132
	],
	"./ms/learn.json": [
		10132,
		10132
	],
	"./ms/login": [
		128,
		128
	],
	"./ms/login.json": [
		128,
		128
	],
	"./ms/notes": [
		5008,
		5008
	],
	"./ms/notes.json": [
		5008,
		5008
	],
	"./ms/notification-settings": [
		77016,
		77016
	],
	"./ms/notification-settings.json": [
		77016,
		77016
	],
	"./ms/onboarding": [
		99634,
		63085
	],
	"./ms/onboarding.json": [
		99634,
		63085
	],
	"./ms/privacy": [
		39746,
		39746
	],
	"./ms/privacy.json": [
		39746,
		39746
	],
	"./ms/product-updates": [
		56495,
		56495
	],
	"./ms/product-updates.json": [
		56495,
		56495
	],
	"./ms/profile": [
		83461,
		83461
	],
	"./ms/profile.json": [
		83461,
		83461
	],
	"./ms/quick-links": [
		1017,
		1017
	],
	"./ms/quick-links.json": [
		1017,
		1017
	],
	"./ms/quran-reader": [
		11242,
		11242
	],
	"./ms/quran-reader.json": [
		11242,
		11242
	],
	"./ms/quranic-calendar": [
		46584,
		46584
	],
	"./ms/quranic-calendar.json": [
		46584,
		46584
	],
	"./ms/radio": [
		3787,
		3787
	],
	"./ms/radio.json": [
		3787,
		3787
	],
	"./ms/ramadan-activities": [
		9590,
		9590
	],
	"./ms/ramadan-activities.json": [
		9590,
		9590
	],
	"./ms/reading-goal": [
		85582,
		85582
	],
	"./ms/reading-goal.json": [
		85582,
		85582
	],
	"./ms/reading-progress": [
		61484,
		61484
	],
	"./ms/reading-progress.json": [
		61484,
		61484
	],
	"./ms/reciter": [
		83546,
		83546
	],
	"./ms/reciter.json": [
		83546,
		83546
	],
	"./ms/search": [
		80561,
		80561
	],
	"./ms/search.json": [
		80561,
		80561
	],
	"./ms/support": [
		91036,
		91036
	],
	"./ms/support.json": [
		91036,
		91036
	],
	"./ms/surah-info": [
		89413,
		89413
	],
	"./ms/surah-info.json": [
		89413,
		89413
	],
	"./ms/tajweed": [
		71501,
		71501
	],
	"./ms/tajweed.json": [
		71501,
		71501
	],
	"./nl/about": [
		63113,
		63113
	],
	"./nl/about-quran": [
		29687,
		29687
	],
	"./nl/about-quran.json": [
		29687,
		29687
	],
	"./nl/about.json": [
		63113,
		63113
	],
	"./nl/apps": [
		30496,
		30496
	],
	"./nl/apps.json": [
		30496,
		30496
	],
	"./nl/chapter": [
		7451,
		7451
	],
	"./nl/chapter.json": [
		7451,
		7451
	],
	"./nl/collection": [
		49409,
		49409
	],
	"./nl/collection.json": [
		49409,
		49409
	],
	"./nl/common": [
		1211,
		1211
	],
	"./nl/common.json": [
		1211,
		1211
	],
	"./nl/developers": [
		96780,
		96780
	],
	"./nl/developers.json": [
		96780,
		96780
	],
	"./nl/error": [
		57744,
		57744
	],
	"./nl/error.json": [
		57744,
		57744
	],
	"./nl/home": [
		86385,
		86385
	],
	"./nl/home.json": [
		86385,
		86385
	],
	"./nl/learn": [
		15632,
		15632
	],
	"./nl/learn.json": [
		15632,
		15632
	],
	"./nl/login": [
		75083,
		75083
	],
	"./nl/login.json": [
		75083,
		75083
	],
	"./nl/notes": [
		83002,
		83002
	],
	"./nl/notes.json": [
		83002,
		83002
	],
	"./nl/notification-settings": [
		4939,
		4939
	],
	"./nl/notification-settings.json": [
		4939,
		4939
	],
	"./nl/onboarding": [
		67565,
		67565
	],
	"./nl/onboarding.json": [
		67565,
		67565
	],
	"./nl/privacy": [
		80100,
		80100
	],
	"./nl/privacy.json": [
		80100,
		80100
	],
	"./nl/product-updates": [
		29175,
		29175
	],
	"./nl/product-updates.json": [
		29175,
		29175
	],
	"./nl/profile": [
		86583,
		86583
	],
	"./nl/profile.json": [
		86583,
		86583
	],
	"./nl/quick-links": [
		45960,
		45960
	],
	"./nl/quick-links.json": [
		45960,
		45960
	],
	"./nl/quran-reader": [
		8322,
		8322
	],
	"./nl/quran-reader.json": [
		8322,
		8322
	],
	"./nl/quranic-calendar": [
		50642,
		50642
	],
	"./nl/quranic-calendar.json": [
		50642,
		50642
	],
	"./nl/radio": [
		13878,
		13878
	],
	"./nl/radio.json": [
		13878,
		13878
	],
	"./nl/ramadan-activities": [
		46633,
		46633
	],
	"./nl/ramadan-activities.json": [
		46633,
		46633
	],
	"./nl/reading-goal": [
		80279,
		80279
	],
	"./nl/reading-goal.json": [
		80279,
		80279
	],
	"./nl/reading-progress": [
		43990,
		43990
	],
	"./nl/reading-progress.json": [
		43990,
		43990
	],
	"./nl/reciter": [
		95073,
		95073
	],
	"./nl/reciter.json": [
		95073,
		95073
	],
	"./nl/search": [
		10308,
		10308
	],
	"./nl/search.json": [
		10308,
		10308
	],
	"./nl/support": [
		76263,
		76263
	],
	"./nl/support.json": [
		76263,
		76263
	],
	"./nl/surah-info": [
		48168,
		48168
	],
	"./nl/surah-info.json": [
		48168,
		48168
	],
	"./nl/tajweed": [
		7999,
		7999
	],
	"./nl/tajweed.json": [
		7999,
		7999
	],
	"./pt/about": [
		5891,
		5891
	],
	"./pt/about-quran": [
		50657,
		50657
	],
	"./pt/about-quran.json": [
		50657,
		50657
	],
	"./pt/about.json": [
		5891,
		5891
	],
	"./pt/apps": [
		1787,
		1787
	],
	"./pt/apps.json": [
		1787,
		1787
	],
	"./pt/chapter": [
		20833,
		20833
	],
	"./pt/chapter.json": [
		20833,
		20833
	],
	"./pt/collection": [
		99625,
		99625
	],
	"./pt/collection.json": [
		99625,
		99625
	],
	"./pt/common": [
		41400,
		41400
	],
	"./pt/common.json": [
		41400,
		41400
	],
	"./pt/developers": [
		21378,
		21378
	],
	"./pt/developers.json": [
		21378,
		21378
	],
	"./pt/error": [
		31374,
		31374
	],
	"./pt/error.json": [
		31374,
		31374
	],
	"./pt/home": [
		44766,
		44766
	],
	"./pt/home.json": [
		44766,
		44766
	],
	"./pt/learn": [
		86561,
		86561
	],
	"./pt/learn.json": [
		86561,
		86561
	],
	"./pt/login": [
		13192,
		13192
	],
	"./pt/login.json": [
		13192,
		13192
	],
	"./pt/notes": [
		92342,
		92342
	],
	"./pt/notes.json": [
		92342,
		92342
	],
	"./pt/notification-settings": [
		28007,
		28007
	],
	"./pt/notification-settings.json": [
		28007,
		28007
	],
	"./pt/onboarding": [
		25232,
		25232
	],
	"./pt/onboarding.json": [
		25232,
		25232
	],
	"./pt/privacy": [
		25283,
		25283
	],
	"./pt/privacy.json": [
		25283,
		25283
	],
	"./pt/product-updates": [
		13850,
		13850
	],
	"./pt/product-updates.json": [
		13850,
		13850
	],
	"./pt/profile": [
		22854,
		22854
	],
	"./pt/profile.json": [
		22854,
		22854
	],
	"./pt/quick-links": [
		64394,
		64394
	],
	"./pt/quick-links.json": [
		64394,
		64394
	],
	"./pt/quran-reader": [
		22527,
		22527
	],
	"./pt/quran-reader.json": [
		22527,
		22527
	],
	"./pt/quranic-calendar": [
		79732,
		79732
	],
	"./pt/quranic-calendar.json": [
		79732,
		79732
	],
	"./pt/radio": [
		72575,
		72575
	],
	"./pt/radio.json": [
		72575,
		72575
	],
	"./pt/ramadan-activities": [
		10477,
		10477
	],
	"./pt/ramadan-activities.json": [
		10477,
		10477
	],
	"./pt/reading-goal": [
		12171,
		12171
	],
	"./pt/reading-goal.json": [
		12171,
		12171
	],
	"./pt/reading-progress": [
		22360,
		22360
	],
	"./pt/reading-progress.json": [
		22360,
		22360
	],
	"./pt/reciter": [
		76804,
		76804
	],
	"./pt/reciter.json": [
		76804,
		76804
	],
	"./pt/search": [
		8302,
		8302
	],
	"./pt/search.json": [
		8302,
		8302
	],
	"./pt/support": [
		94109,
		94109
	],
	"./pt/support.json": [
		94109,
		94109
	],
	"./pt/surah-info": [
		48580,
		48580
	],
	"./pt/surah-info.json": [
		48580,
		48580
	],
	"./pt/tajweed": [
		89925,
		89925
	],
	"./pt/tajweed.json": [
		89925,
		89925
	],
	"./ru/about": [
		6217,
		6217
	],
	"./ru/about-quran": [
		68779,
		68779
	],
	"./ru/about-quran.json": [
		68779,
		68779
	],
	"./ru/about.json": [
		6217,
		6217
	],
	"./ru/apps": [
		95147,
		95147
	],
	"./ru/apps.json": [
		95147,
		95147
	],
	"./ru/chapter": [
		25758,
		25758
	],
	"./ru/chapter.json": [
		25758,
		25758
	],
	"./ru/collection": [
		2735,
		2735
	],
	"./ru/collection.json": [
		2735,
		2735
	],
	"./ru/common": [
		77247,
		77247
	],
	"./ru/common.json": [
		77247,
		77247
	],
	"./ru/developers": [
		57132,
		57132
	],
	"./ru/developers.json": [
		57132,
		57132
	],
	"./ru/error": [
		8104,
		8104
	],
	"./ru/error.json": [
		8104,
		8104
	],
	"./ru/home": [
		32503,
		32503
	],
	"./ru/home.json": [
		32503,
		32503
	],
	"./ru/learn": [
		86058,
		86058
	],
	"./ru/learn.json": [
		86058,
		86058
	],
	"./ru/login": [
		87653,
		87653
	],
	"./ru/login.json": [
		87653,
		87653
	],
	"./ru/notes": [
		15965,
		15965
	],
	"./ru/notes.json": [
		15965,
		15965
	],
	"./ru/notification-settings": [
		67975,
		67975
	],
	"./ru/notification-settings.json": [
		67975,
		67975
	],
	"./ru/onboarding": [
		25024,
		25024
	],
	"./ru/onboarding.json": [
		25024,
		25024
	],
	"./ru/privacy": [
		28771,
		28771
	],
	"./ru/privacy.json": [
		28771,
		28771
	],
	"./ru/product-updates": [
		45111,
		45111
	],
	"./ru/product-updates.json": [
		45111,
		45111
	],
	"./ru/profile": [
		87157,
		87157
	],
	"./ru/profile.json": [
		87157,
		87157
	],
	"./ru/quick-links": [
		69373,
		69373
	],
	"./ru/quick-links.json": [
		69373,
		69373
	],
	"./ru/quran-reader": [
		88041,
		88041
	],
	"./ru/quran-reader.json": [
		88041,
		88041
	],
	"./ru/quranic-calendar": [
		67606,
		67606
	],
	"./ru/quranic-calendar.json": [
		67606,
		67606
	],
	"./ru/radio": [
		69511,
		69511
	],
	"./ru/radio.json": [
		69511,
		69511
	],
	"./ru/ramadan-activities": [
		59974,
		59974
	],
	"./ru/ramadan-activities.json": [
		59974,
		59974
	],
	"./ru/reading-goal": [
		43156,
		43156
	],
	"./ru/reading-goal.json": [
		43156,
		43156
	],
	"./ru/reading-progress": [
		87089,
		87089
	],
	"./ru/reading-progress.json": [
		87089,
		87089
	],
	"./ru/reciter": [
		82554,
		82554
	],
	"./ru/reciter.json": [
		82554,
		82554
	],
	"./ru/search": [
		77193,
		77193
	],
	"./ru/search.json": [
		77193,
		77193
	],
	"./ru/support": [
		52074,
		52074
	],
	"./ru/support.json": [
		52074,
		52074
	],
	"./ru/surah-info": [
		84967,
		84967
	],
	"./ru/surah-info.json": [
		84967,
		84967
	],
	"./ru/tajweed": [
		42932,
		42932
	],
	"./ru/tajweed.json": [
		42932,
		42932
	],
	"./sq/about": [
		1471,
		1471
	],
	"./sq/about-quran": [
		49361,
		49361
	],
	"./sq/about-quran.json": [
		49361,
		49361
	],
	"./sq/about.json": [
		1471,
		1471
	],
	"./sq/apps": [
		75248,
		75248
	],
	"./sq/apps.json": [
		75248,
		75248
	],
	"./sq/chapter": [
		85083,
		9636
	],
	"./sq/chapter.json": [
		85083,
		9636
	],
	"./sq/collection": [
		38326,
		38326
	],
	"./sq/collection.json": [
		38326,
		38326
	],
	"./sq/common": [
		22937,
		22937
	],
	"./sq/common.json": [
		22937,
		22937
	],
	"./sq/developers": [
		86418,
		86418
	],
	"./sq/developers.json": [
		86418,
		86418
	],
	"./sq/error": [
		62322,
		62322
	],
	"./sq/error.json": [
		62322,
		62322
	],
	"./sq/home": [
		8951,
		8951
	],
	"./sq/home.json": [
		8951,
		8951
	],
	"./sq/learn": [
		96543,
		96543
	],
	"./sq/learn.json": [
		96543,
		96543
	],
	"./sq/login": [
		39725,
		39725
	],
	"./sq/login.json": [
		39725,
		39725
	],
	"./sq/notes": [
		36464,
		36464
	],
	"./sq/notes.json": [
		36464,
		36464
	],
	"./sq/notification-settings": [
		5781,
		5781
	],
	"./sq/notification-settings.json": [
		5781,
		5781
	],
	"./sq/onboarding": [
		72873,
		72873
	],
	"./sq/onboarding.json": [
		72873,
		72873
	],
	"./sq/privacy": [
		46448,
		46448
	],
	"./sq/privacy.json": [
		46448,
		46448
	],
	"./sq/product-updates": [
		90650,
		90650
	],
	"./sq/product-updates.json": [
		90650,
		90650
	],
	"./sq/profile": [
		96682,
		96682
	],
	"./sq/profile.json": [
		96682,
		96682
	],
	"./sq/quick-links": [
		36048,
		36048
	],
	"./sq/quick-links.json": [
		36048,
		36048
	],
	"./sq/quran-reader": [
		10476,
		10476
	],
	"./sq/quran-reader.json": [
		10476,
		10476
	],
	"./sq/quranic-calendar": [
		89274,
		89274
	],
	"./sq/quranic-calendar.json": [
		89274,
		89274
	],
	"./sq/radio": [
		705,
		705
	],
	"./sq/radio.json": [
		705,
		705
	],
	"./sq/ramadan-activities": [
		70957,
		70957
	],
	"./sq/ramadan-activities.json": [
		70957,
		70957
	],
	"./sq/reading-goal": [
		74696,
		67332
	],
	"./sq/reading-goal.json": [
		74696,
		67332
	],
	"./sq/reading-progress": [
		8288,
		8288
	],
	"./sq/reading-progress.json": [
		8288,
		8288
	],
	"./sq/reciter": [
		37257,
		37257
	],
	"./sq/reciter.json": [
		37257,
		37257
	],
	"./sq/search": [
		86609,
		86609
	],
	"./sq/search.json": [
		86609,
		86609
	],
	"./sq/support": [
		20801,
		20801
	],
	"./sq/support.json": [
		20801,
		20801
	],
	"./sq/surah-info": [
		16726,
		16726
	],
	"./sq/surah-info.json": [
		16726,
		16726
	],
	"./sq/tajweed": [
		24733,
		24733
	],
	"./sq/tajweed.json": [
		24733,
		24733
	],
	"./th/about": [
		47030,
		47030
	],
	"./th/about-quran": [
		59288,
		59288
	],
	"./th/about-quran.json": [
		59288,
		59288
	],
	"./th/about.json": [
		47030,
		47030
	],
	"./th/apps": [
		50249,
		50249
	],
	"./th/apps.json": [
		50249,
		50249
	],
	"./th/chapter": [
		6735,
		6735
	],
	"./th/chapter.json": [
		6735,
		6735
	],
	"./th/collection": [
		78294,
		78294
	],
	"./th/collection.json": [
		78294,
		78294
	],
	"./th/common": [
		63303,
		63303
	],
	"./th/common.json": [
		63303,
		63303
	],
	"./th/developers": [
		42529,
		42529
	],
	"./th/developers.json": [
		42529,
		42529
	],
	"./th/error": [
		75496,
		75496
	],
	"./th/error.json": [
		75496,
		75496
	],
	"./th/home": [
		61686,
		61686
	],
	"./th/home.json": [
		61686,
		61686
	],
	"./th/learn": [
		38984,
		38984
	],
	"./th/learn.json": [
		38984,
		38984
	],
	"./th/login": [
		98915,
		98915
	],
	"./th/login.json": [
		98915,
		98915
	],
	"./th/notes": [
		30741,
		30741
	],
	"./th/notes.json": [
		30741,
		30741
	],
	"./th/notification-settings": [
		29802,
		29802
	],
	"./th/notification-settings.json": [
		29802,
		29802
	],
	"./th/onboarding": [
		99442,
		99442
	],
	"./th/onboarding.json": [
		99442,
		99442
	],
	"./th/privacy": [
		51890,
		51890
	],
	"./th/privacy.json": [
		51890,
		51890
	],
	"./th/product-updates": [
		11329,
		11329
	],
	"./th/product-updates.json": [
		11329,
		11329
	],
	"./th/profile": [
		43671,
		43671
	],
	"./th/profile.json": [
		43671,
		43671
	],
	"./th/quick-links": [
		82010,
		82010
	],
	"./th/quick-links.json": [
		82010,
		82010
	],
	"./th/quran-reader": [
		31301,
		31301
	],
	"./th/quran-reader.json": [
		31301,
		31301
	],
	"./th/quranic-calendar": [
		76792,
		76792
	],
	"./th/quranic-calendar.json": [
		76792,
		76792
	],
	"./th/radio": [
		20364,
		20364
	],
	"./th/radio.json": [
		20364,
		20364
	],
	"./th/ramadan-activities": [
		37595,
		37595
	],
	"./th/ramadan-activities.json": [
		37595,
		37595
	],
	"./th/reading-goal": [
		56927,
		56927
	],
	"./th/reading-goal.json": [
		56927,
		56927
	],
	"./th/reading-progress": [
		44444,
		44444
	],
	"./th/reading-progress.json": [
		44444,
		44444
	],
	"./th/reciter": [
		95142,
		95142
	],
	"./th/reciter.json": [
		95142,
		95142
	],
	"./th/search": [
		15178,
		15178
	],
	"./th/search.json": [
		15178,
		15178
	],
	"./th/support": [
		90933,
		90933
	],
	"./th/support.json": [
		90933,
		90933
	],
	"./th/surah-info": [
		57855,
		57855
	],
	"./th/surah-info.json": [
		57855,
		57855
	],
	"./th/tajweed": [
		87880,
		87880
	],
	"./th/tajweed.json": [
		87880,
		87880
	],
	"./tr/about": [
		84602,
		84602
	],
	"./tr/about-quran": [
		98213,
		98213
	],
	"./tr/about-quran.json": [
		98213,
		98213
	],
	"./tr/about.json": [
		84602,
		84602
	],
	"./tr/apps": [
		12445,
		12445
	],
	"./tr/apps.json": [
		12445,
		12445
	],
	"./tr/chapter": [
		51528,
		51528
	],
	"./tr/chapter.json": [
		51528,
		51528
	],
	"./tr/collection": [
		38104,
		38104
	],
	"./tr/collection.json": [
		38104,
		38104
	],
	"./tr/common": [
		72973,
		72973
	],
	"./tr/common.json": [
		72973,
		72973
	],
	"./tr/developers": [
		60417,
		60417
	],
	"./tr/developers.json": [
		60417,
		60417
	],
	"./tr/error": [
		47328,
		47328
	],
	"./tr/error.json": [
		47328,
		47328
	],
	"./tr/home": [
		27646,
		27646
	],
	"./tr/home.json": [
		27646,
		27646
	],
	"./tr/learn": [
		29940,
		29940
	],
	"./tr/learn.json": [
		29940,
		29940
	],
	"./tr/login": [
		99237,
		99237
	],
	"./tr/login.json": [
		99237,
		99237
	],
	"./tr/notes": [
		1639,
		1639
	],
	"./tr/notes.json": [
		1639,
		1639
	],
	"./tr/notification-settings": [
		65673,
		65673
	],
	"./tr/notification-settings.json": [
		65673,
		65673
	],
	"./tr/onboarding": [
		126,
		126
	],
	"./tr/onboarding.json": [
		126,
		126
	],
	"./tr/privacy": [
		25937,
		25937
	],
	"./tr/privacy.json": [
		25937,
		25937
	],
	"./tr/product-updates": [
		22771,
		22771
	],
	"./tr/product-updates.json": [
		22771,
		22771
	],
	"./tr/profile": [
		52140,
		52140
	],
	"./tr/profile.json": [
		52140,
		52140
	],
	"./tr/quick-links": [
		44202,
		44202
	],
	"./tr/quick-links.json": [
		44202,
		44202
	],
	"./tr/quran-reader": [
		21552,
		21552
	],
	"./tr/quran-reader.json": [
		21552,
		21552
	],
	"./tr/quranic-calendar": [
		49934,
		49934
	],
	"./tr/quranic-calendar.json": [
		49934,
		49934
	],
	"./tr/radio": [
		64431,
		64431
	],
	"./tr/radio.json": [
		64431,
		64431
	],
	"./tr/ramadan-activities": [
		35058,
		35058
	],
	"./tr/ramadan-activities.json": [
		35058,
		35058
	],
	"./tr/reading-goal": [
		71990,
		71990
	],
	"./tr/reading-goal.json": [
		71990,
		71990
	],
	"./tr/reading-progress": [
		22768,
		22768
	],
	"./tr/reading-progress.json": [
		22768,
		22768
	],
	"./tr/reciter": [
		59535,
		59535
	],
	"./tr/reciter.json": [
		59535,
		59535
	],
	"./tr/search": [
		64171,
		64171
	],
	"./tr/search.json": [
		64171,
		64171
	],
	"./tr/support": [
		86015,
		86015
	],
	"./tr/support.json": [
		86015,
		86015
	],
	"./tr/surah-info": [
		55983,
		55983
	],
	"./tr/surah-info.json": [
		55983,
		55983
	],
	"./tr/tajweed": [
		40754,
		40754
	],
	"./tr/tajweed.json": [
		40754,
		40754
	],
	"./ur/about": [
		92239,
		92239
	],
	"./ur/about-quran": [
		14729,
		14729
	],
	"./ur/about-quran.json": [
		14729,
		14729
	],
	"./ur/about.json": [
		92239,
		92239
	],
	"./ur/apps": [
		25032,
		54847
	],
	"./ur/apps.json": [
		25032,
		54847
	],
	"./ur/chapter": [
		98510,
		98510
	],
	"./ur/chapter.json": [
		98510,
		98510
	],
	"./ur/collection": [
		22084,
		22084
	],
	"./ur/collection.json": [
		22084,
		22084
	],
	"./ur/common": [
		45597,
		45597
	],
	"./ur/common.json": [
		45597,
		45597
	],
	"./ur/developers": [
		57171,
		57171
	],
	"./ur/developers.json": [
		57171,
		57171
	],
	"./ur/error": [
		77140,
		77140
	],
	"./ur/error.json": [
		77140,
		77140
	],
	"./ur/home": [
		5321,
		5321
	],
	"./ur/home.json": [
		5321,
		5321
	],
	"./ur/learn": [
		44856,
		44856
	],
	"./ur/learn.json": [
		44856,
		44856
	],
	"./ur/login": [
		36602,
		36602
	],
	"./ur/login.json": [
		36602,
		36602
	],
	"./ur/notes": [
		92339,
		92339
	],
	"./ur/notes.json": [
		92339,
		92339
	],
	"./ur/notification-settings": [
		45877,
		45877
	],
	"./ur/notification-settings.json": [
		45877,
		45877
	],
	"./ur/onboarding": [
		89069,
		89069
	],
	"./ur/onboarding.json": [
		89069,
		89069
	],
	"./ur/privacy": [
		21419,
		21419
	],
	"./ur/privacy.json": [
		21419,
		21419
	],
	"./ur/product-updates": [
		83821,
		83821
	],
	"./ur/product-updates.json": [
		83821,
		83821
	],
	"./ur/profile": [
		58438,
		58438
	],
	"./ur/profile.json": [
		58438,
		58438
	],
	"./ur/quick-links": [
		73201,
		73201
	],
	"./ur/quick-links.json": [
		73201,
		73201
	],
	"./ur/quran-reader": [
		49639,
		49639
	],
	"./ur/quran-reader.json": [
		49639,
		49639
	],
	"./ur/quranic-calendar": [
		14523,
		14523
	],
	"./ur/quranic-calendar.json": [
		14523,
		14523
	],
	"./ur/radio": [
		10621,
		10621
	],
	"./ur/radio.json": [
		10621,
		10621
	],
	"./ur/ramadan-activities": [
		54338,
		54338
	],
	"./ur/ramadan-activities.json": [
		54338,
		54338
	],
	"./ur/reading-goal": [
		45023,
		45023
	],
	"./ur/reading-goal.json": [
		45023,
		45023
	],
	"./ur/reading-progress": [
		34987,
		34987
	],
	"./ur/reading-progress.json": [
		34987,
		34987
	],
	"./ur/reciter": [
		75279,
		75279
	],
	"./ur/reciter.json": [
		75279,
		75279
	],
	"./ur/search": [
		16037,
		16037
	],
	"./ur/search.json": [
		16037,
		16037
	],
	"./ur/support": [
		84183,
		84183
	],
	"./ur/support.json": [
		84183,
		84183
	],
	"./ur/surah-info": [
		506,
		506
	],
	"./ur/surah-info.json": [
		506,
		506
	],
	"./ur/tajweed": [
		44526,
		44526
	],
	"./ur/tajweed.json": [
		44526,
		44526
	],
	"./zh/about": [
		23318,
		23318
	],
	"./zh/about-quran": [
		65627,
		65627
	],
	"./zh/about-quran.json": [
		65627,
		65627
	],
	"./zh/about.json": [
		23318,
		23318
	],
	"./zh/apps": [
		33007,
		33007
	],
	"./zh/apps.json": [
		33007,
		33007
	],
	"./zh/chapter": [
		7503,
		7503
	],
	"./zh/chapter.json": [
		7503,
		7503
	],
	"./zh/collection": [
		11602,
		11602
	],
	"./zh/collection.json": [
		11602,
		11602
	],
	"./zh/common": [
		66671,
		66671
	],
	"./zh/common.json": [
		66671,
		66671
	],
	"./zh/developers": [
		53328,
		53328
	],
	"./zh/developers.json": [
		53328,
		53328
	],
	"./zh/error": [
		19846,
		19846
	],
	"./zh/error.json": [
		19846,
		19846
	],
	"./zh/home": [
		93056,
		93056
	],
	"./zh/home.json": [
		93056,
		93056
	],
	"./zh/learn": [
		6842,
		6842
	],
	"./zh/learn.json": [
		6842,
		6842
	],
	"./zh/login": [
		20292,
		20292
	],
	"./zh/login.json": [
		20292,
		20292
	],
	"./zh/notes": [
		13421,
		13421
	],
	"./zh/notes.json": [
		13421,
		13421
	],
	"./zh/notification-settings": [
		59604,
		59604
	],
	"./zh/notification-settings.json": [
		59604,
		59604
	],
	"./zh/onboarding": [
		46079,
		46079
	],
	"./zh/onboarding.json": [
		46079,
		46079
	],
	"./zh/privacy": [
		94699,
		94699
	],
	"./zh/privacy.json": [
		94699,
		94699
	],
	"./zh/product-updates": [
		65869,
		65869
	],
	"./zh/product-updates.json": [
		65869,
		65869
	],
	"./zh/profile": [
		98382,
		98382
	],
	"./zh/profile.json": [
		98382,
		98382
	],
	"./zh/quick-links": [
		85571,
		85571
	],
	"./zh/quick-links.json": [
		85571,
		85571
	],
	"./zh/quran-reader": [
		72056,
		72056
	],
	"./zh/quran-reader.json": [
		72056,
		72056
	],
	"./zh/quranic-calendar": [
		91418,
		91418
	],
	"./zh/quranic-calendar.json": [
		91418,
		91418
	],
	"./zh/radio": [
		21103,
		21103
	],
	"./zh/radio.json": [
		21103,
		21103
	],
	"./zh/ramadan-activities": [
		27986,
		27986
	],
	"./zh/ramadan-activities.json": [
		27986,
		27986
	],
	"./zh/reading-goal": [
		65474,
		65474
	],
	"./zh/reading-goal.json": [
		65474,
		65474
	],
	"./zh/reading-progress": [
		9315,
		9315
	],
	"./zh/reading-progress.json": [
		9315,
		9315
	],
	"./zh/reciter": [
		1454,
		1454
	],
	"./zh/reciter.json": [
		1454,
		1454
	],
	"./zh/search": [
		58020,
		58020
	],
	"./zh/search.json": [
		58020,
		58020
	],
	"./zh/support": [
		79306,
		79306
	],
	"./zh/support.json": [
		79306,
		79306
	],
	"./zh/surah-info": [
		62199,
		62199
	],
	"./zh/surah-info.json": [
		62199,
		62199
	],
	"./zh/tajweed": [
		40651,
		40651
	],
	"./zh/tajweed.json": [
		40651,
		40651
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 30242;
module.exports = webpackAsyncContext;